import React, { useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { WidgetsData } from "./WidgetsData";
import '../global/GlobalCSS.css'
import Layout from "../HorizontalMenu/Menu";
import Navbar from "../HorizontalMenu/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "index";
import { VesselState, getVesselsAction, setReportID, setVesselState, setVoyageID } from "Store/Generic/ReportingSlice";
import PendingFiles from "./PendingFiles";
import { Roles, VesselTypeConstant } from "shared/constants";
import PendingLNGCargoDetails from "./PendingLNGCargoDetails";
import DashboardFleet from "./DashboardFleet";
import { hasRole } from "utils/auth/authUtils";
import { loadLastReportVessel, loadUserVessel, loadVesselCardDetails } from "VesselMaster/vesselMaster.hooks";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import VesselCard from "Components/VesselCard";
import { Link } from "react-router-dom";
import CreateVesselReport from "VesselReportingInfo/CreateVesselReport";

const Dashboard = () => {
    /** State variables */
    const { Vessels, VesselID, VesselState } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();
    /** State varibles end */

    /** useEffect */
    useEffect(() => {
        dispatch(getVesselsAction('vessel_master' as string));
    }, [dispatch]);
    /** useEffect end */

    /** Queries */
    /** Vessel assigned to user  */
    const { data: UserVessel }:
        { data: any[], isLoading: any, isError: any } = useQuery(
            [queryKeyes.vessel.UserVessel.key],
            async () => {
                return await loadUserVessel();
            },
            { staleTime: Infinity }
        );
    /** Vessel card details */
    const { data: CardDetails } = useQuery(
        [queryKeyes.vessel.VesselCardDetails.key],
        async () => {
            return await loadVesselCardDetails()
        },
        {
            enabled: true,
        }
    );
    /** Vessel's last report */
    const { data: LastVesselReport } = useQuery(
        [queryKeyes.vessel.LastVesselReport.key, VesselID],
        async () => {
            return await loadLastReportVessel(VesselID)
        },
        {
            enabled: true,
        }
    );
    /** Queries end */

    useEffect(() => {
        //     const lat = 18.5204;
        //     const lng = 73.8567;
        //     const params = 'waveHeight,airTemperature';

        //     fetch(`https://api.stormglass.io/v2/weather/point?lat=${lat}&lng=${lng}&params=${params}&start=2024-05-06T00:00:00`, {
        //         headers: {
        //             'Authorization': '438d0e56-0b9c-11ef-bf69-0242ac130002-438d0f00-0b9c-11ef-bf69-0242ac130002'
        //         }
        //     }).then((response) => response.json()).then((jsonData) => {
        //         // Do something with response data.
        //     });
        if (LastVesselReport !== undefined) {
            dispatch(setVoyageID(LastVesselReport?.voyage_information))
        }
    }, [LastVesselReport, dispatch])

    const ValidVessels: any = Vessels.filter((vessel: any) => vessel.display === true);

    // const methodDoesNotExist = () => {
    //     throw new Error('Error hit');
    // }
    const userVesselMaster = UserVessel?.filter((item: any) => item.constant === Roles.MASTER)[0]?.vessel[0]
    const userVesselEngineer = UserVessel?.filter((item: any) => item.constant === Roles.CHIEFENGINEER)[0]?.vessel[0]

    const handleVesselState = (reportId: number, record: VesselState) => {


        dispatch(setReportID(reportId))
        dispatch(setVesselState(record))
    }

    return (
        <React.Fragment>
            <Layout children={Navbar} />
            <div className="page-content" style={{ paddingTop: '2rem' }}>
                <Container fluid>
                    <h4 style={{ 'display': 'inline' }} key={'dashboard'} className="page_title">Dashboard</h4>
                    {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER)) && ValidVessels &&
                        <>
                            <Row key={'dashboard-widget'}>
                                {(WidgetsData || []).map((widget: any, index: number) => (
                                    <Col lg={3} key={widget.id}>
                                        <Card className="max-h-20">
                                            <CardBody className={"badge-soft-" +
                                                widget.statusColor +
                                                " text-" +
                                                widget.statusColor}>
                                                <Row className="align-items-center">
                                                    <Col xs={6}>
                                                        <span className="text-muted mb-3 lh-1 d-block w-7">
                                                            {widget.title}
                                                        </span>
                                                    </Col>
                                                </Row>
                                                <div className="text-nowrap wid-data">
                                                    <span className="primary-label">{(ValidVessels.length)}</span>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                                {/* <Col >
                                    <button onClick={() => methodDoesNotExist()}>Break the world</button>
                                </Col> */}
                            </Row>
                        </>
                    }
                    {(hasRole(Roles.ES_ADMIN) ||
                        hasRole(Roles.MANAGER)) &&
                        <Row>
                            <DashboardFleet />
                        </Row>
                    }
                    {hasRole(Roles.MASTER) &&
                        <Row>
                            <Col lg={4}>
                                <VesselCard Vessels={CardDetails?.filter((item: any) => item.vessel_id === userVesselMaster)} />
                            </Col>
                            <Col lg={{ size: 3, offset: 5 }}>
                                <Link
                                    to="/masters/vessel_master">
                                    <button color='primary' className='btn btn-primary mb-3' onClick={() => {
                                        handleVesselState(-1, 'CREATE_VESSEL_REPORTING');
                                    }}>
                                        <i className="dripicons-plus font-size-16 align-middle me-2" />
                                        Create New Report
                                    </button>
                                </Link>
                            </Col>
                        </Row>
                    }
                    {hasRole(Roles.CHIEFENGINEER) &&
                        <Row className="mt-3">
                            <Col lg={4}>
                                <VesselCard Vessels={CardDetails?.filter((item: any) => item.vessel_id === userVesselEngineer)} />
                            </Col>
                        </Row>
                    }
                    {(hasRole(Roles.ES_ADMIN) ||
                        hasRole(Roles.MANAGER) ||
                        hasRole(Roles.MASTER) ||
                        hasRole(Roles.CHIEFENGINEER)) &&
                        <Row>
                            <PendingFiles vessel={
                                hasRole(Roles.MASTER) ?
                                    UserVessel?.filter((item: any) => item.constant === Roles.MASTER)[0]?.vessel[0] :
                                    hasRole(Roles.CHIEFENGINEER) ?
                                        UserVessel?.filter((item: any) => item.constant === Roles.CHIEFENGINEER)[0]?.vessel[0] :
                                        VesselID
                            } />
                        </Row>
                    }
                    {(hasRole(Roles.ES_ADMIN) ||
                        hasRole(Roles.MANAGER) ||
                        hasRole(Roles.MASTER) ||
                        hasRole(Roles.CHIEFENGINEER)) &&
                        ValidVessels.filter((item: any) => item.id === VesselID &&
                            item.vessel_type === VesselTypeConstant.LNG_CARRIER).length > 0 &&
                        <PendingLNGCargoDetails VesselID={
                            hasRole(Roles.MASTER) ?
                                UserVessel?.filter((item: any) => item.constant === Roles.MASTER)[0]?.vessel[0] :
                                hasRole(Roles.CHIEFENGINEER) ?
                                    UserVessel?.filter((item: any) => item.constant === Roles.CHIEFENGINEER)[0]?.vessel[0] :
                                    VesselID
                        } />
                    }
                </Container>
            </div>
            {VesselState === 'CREATE_VESSEL_REPORTING' && <CreateVesselReport />}
        </React.Fragment>
    );
};

export default Dashboard;